module.exports = __webpack_public_path__ + "static/media/archive.e591e781.svg";